export var LISTS_TYPE_PREFIX = 'LISTS/';
export var UL = 'UNORDERED-LIST';
export var OL = 'ORDERED-LIST';
export var LI = 'LISTS/LIST-ITEM'; // FIXME: this should have a different prefix to avoid hard coded check, but changing that would need a migration
//# sourceMappingURL=constants.js.map